<template>
    <v-container fluid tag="section">

        <div class="text-end">
            <v-btn outlined class="font-weight-bold me-2" :to="`/locations`">{{ $t('Cancel') }}</v-btn>
            <v-btn color="purple" class="font-weight-bold me-0" @click="onSubmit" :loading="loading" :disabled="loading">{{ $t('Save') }}</v-btn>
        </div>

        <v-row>
            <v-col cols="12">
                <v-card class="rounded-lg mt-2">
                    <v-card-text class="px-0 py-0">
                        <v-form>
                            <v-container>
                                <v-text-field v-model="item.name" :label="$t('Name')"></v-text-field>
                                <v-select v-model="item.company_id" :label="$t('Company')" :items="companies"
                                item-text="name" item-value="id"></v-select>
                                <v-text-field v-model="item.subdomain" :label="$t('Subdomain')"></v-text-field>
                                <v-img v-if="item.urls?.logo" :src="item.urls.logo" max-height="64" max-width="64"></v-img>
                                <v-file-input v-model="item.logo" :label="$t('Logo')" truncate-length="25" prepend-icon="mdi-image"></v-file-input>
                                <v-img v-if="item.urls?.image" :src="item.urls.image" max-height="64" max-width="64"></v-img>
                                <v-file-input v-model="item.image" :label="$t('Image')" truncate-length="25" prepend-icon="mdi-image"></v-file-input>
                                <v-checkbox v-model="item.is_active" :label="$t('Active')"></v-checkbox>
                            </v-container>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import locationService from '@/services/locationService'
import companyService from '@/services/companyService'

export default {
    data() {
        return {
            loading: false,
            item: {
                company_id: null,
                name: null,
                subdomain: null,
                is_active: true,
            },
            companies: []
        }
    },
    async created() {
        if (this.$route.params.id) {
            await this.getLocation(this.$route.params.id)
        }
        this.getCompanies()
    },
    methods: {
        async getLocation(id) {
            try {
                const result = await locationService.get(id)
                this.item = result.data
            } catch (error) {
                this.$dialog.message.error(error.message)
                this.$router.push('/locations')
            }
        },
        async getCompanies() {
            try {
                const result = await companyService.getAll()
                this.companies = result.data
            } catch (error) {
                this.$dialog.message.error(error.message)
            }
        },
        async onSubmit() {
            this.loading = true
            try {
                if (this.$route.params.id) {
                    await locationService.edit(this.$route.params.id, this.item)
                } else {
                    await locationService.add(this.item)
                }
                this.$dialog.message.success(this.$t('Success'))
                this.$router.push('/locations')
            } catch (error) {
                this.$dialog.message.error(error.message)
            }
            this.loading = false
        }
    },
}
</script>